"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainPipeUnion = void 0;
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const UnionOp_js_1 = __importDefault(require("jsts/org/locationtech/jts/operation/union/UnionOp.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
class MainPipeUnion {
    static Union(polylines) {
        const factory = new GeometryFactory_js_1.default();
        let lineStringArr = new Array();
        for (let polyline of polylines) {
            let points = polyline.getPoints();
            let coords = new Array();
            for (let point of points) {
                coords.push(new Coordinate_js_1.default(point.x, point.y));
            }
            lineStringArr.push(factory.createLineString(coords));
        }
        let multiLineString = lineStringArr[0];
        for (let i = 1; i < lineStringArr.length; i++) {
            multiLineString = UnionOp_js_1.default.union(multiLineString, lineStringArr[i]);
        }
        let newLineStringArr = new Array();
        for (let i = 0; i < multiLineString.getNumGeometries(); i++) {
            newLineStringArr.push(multiLineString.getGeometryN(i));
        }
        return newLineStringArr;
    }
}
exports.MainPipeUnion = MainPipeUnion;
